import {defineComponent, onMounted, ref, watch} from 'vue';

export default defineComponent({
  props: ['modelValue', 'label', 'type', 'disabled', 'customId', 'autocomplete'],
  components: {},
  setup: function (props) {
    let innerModelValue: any = ref(undefined);

    onMounted(() => {
      innerModelValue.value = props.modelValue;
    });

    watch(props, () => {
      innerModelValue.value = props.modelValue;
    });

    return {innerModelValue};
  },
});
